let date = new Date();
export const month = locale => {
  let result = date.toLocaleString("en-US", {month: "long"});
  if (locale === "id-ID") {
    result = date.toLocaleString("id-ID", {month: "long"});
  }
  return result;
};
